import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    Productos: [{
        id: 1,
        nombre: "SOFKIA ERP",
        descripcion: "Sistema de Administración de Recursos Empresariales",
        logo: require("@/assets/images/logos_productos/domit.png"),
        imagenDashboard: require("@/assets/images/productos/domit/dashboard.jpeg"),
        imagenPortafolio: require("@/assets/images/productos/domit/domit.jpeg"),
        categoria: "escritorio",
        path: "domit",
        id_sector: 1
      },
      {
        id: 2,
        nombre: "Ntico",
        descripcion: "Sistema de Distribución Móvil",
        logo: require("@/assets/images/logos_productos/sdmsolucion.png"),
        imagenPortafolio: require("@/assets/images/productos/sdm/movil/sdmmovil.jpeg"),
        imagenDashboard: require("@/assets/images/productos/sdm/movil/DashboardFinal.png"),
        imagenPedidos: require("@/assets/images/productos/sdm/movil/Pedidos.png"),
        imagenReportes: require("@/assets/images/productos/sdm/movil/Reportes.png"),
        imagenObjetivos: require("@/assets/images/productos/sdm/movil/objetivoss.png"),
        categoria: "movil",
        path: "SdmMovil",
        id_sector: 2
      },
      // {
      //   id: 4,
      //   nombre: "ADGTask",
      //   descripcion: "Sistema de Administración de Proyectos",
      //   imagenDashboard: require("@/assets/images/productos/task/dashboard.jpeg"),
      //   imagenPortafolio: require("@/assets/images/productos/task/task.jpeg"),
      //   logo: require("@/assets/images/logos_productos/taskmanager.png"),
      //   categoria: "web",
      //   path: "task",
      //   id_sector: 3
      // },
      // {
      //   id: 5,
      //   nombre: "ADGAsistencia",
      //   descripcion: "Sistema de Control Asistencia Empleados",
      //   logo: require("@/assets/images/logos_productos/ponche.png"),
      //   imagenDashboard: require("@/assets/images/productos/ponche/dashboard.jpeg"),
      //   imagenPortafolio: require("@/assets/images/productos/ponche/ponche.jpeg"),
      //   categoria: "escritorio",
      //   path: "ponche",
      //   id_sector: null
      // },
      {
        id: 3,
        nombre: "Ntico Web",
        descripcion: "Sistema de Distribución Móvil Web",
        logo: require("@/assets/images/logos_productos/sdmsolucionweb.png"),
        imagenPortafolio: require("@/assets/images/productos/sdm/web/sdmweb.jpeg"),
        imagenDashboard: require("@/assets/images/productos/sdm/web/dashboard.jpeg"),
        imagenMapaClientes: require("@/assets/images/productos/sdm/web/mapa_clientes.jpeg"),
        imagenReportesActividades: require("@/assets/images/productos/sdm/web/reportes_actividades.jpeg"),
        categoria: "web",
        path: "SdmWeb",
        id_sector: null
      },
      // {
      //   id: 6,
      //   nombre: "Sofía RD",
      //   descripcion: "Sistema de Facturación",
      //   logo: require("@/assets/images/logos_productos/sofia.png"),
      //   imagenPortafolio: require("@/assets/images/productos/sofia/sofia.png"),
      //   imagenDashboard: require("@/assets/images/productos/sofia/dashboard.png"),
      //   categoria: "web",
      //   path: "/",
      //   id_sector: null
      // },
      // {
      //   id: 7,
      //   nombre: "Jaragua_RD",
      //   descripcion: "Punto de Venta",
      //   logo: require("@/assets/images/logos_productos/sdmsolucionweb.png"),
      //   imagenPortafolio: require("@/assets/images/productos/jaragua/jaragua.jpeg"),
      //   imagenDashboard: require("@/assets/images/productos/jaragua/dashboard.jpeg"),
      //   categoria: "escritorio",
      //   path: "/",
      //   id_sector: null
      // }, 
      // {
      //   id: 8,
      //   nombre: "BI",
      //   descripcion: "Sistema de Inteligencia Empresarial",
      //   logo: require("@/assets/images/logos_productos/sdmsolucionweb.png"),
      //   imagenPortafolio: require("@/assets/images/productos/bi/bi.jpeg"),
      //   imagenDashboard: require("@/assets/images/productos/bi/dashboard.jpeg"),
      //   categoria: "web",
      //   path: "/",
      //   id_sector: null
      // },
    ],

    cliente_producto: [{
        id_producto: 2,
        id_cliente: 1
      },
      {
        id_producto: 2,
        id_cliente: 4
      }, {
        id_producto: 2,
        id_cliente: 5
      }, {
        id_producto: 2,
        id_cliente: 6
      }, {
        id_producto: 2,
        id_cliente: 7
      },
      {
        id_producto: 2,
        id_cliente: 9
      },
      {
        id_producto: 3,
        id_cliente: 1
      },
      {
        id_producto: 3,
        id_cliente: 4
      },
      {
        id_producto: 3,
        id_cliente: 9
      }, {
        id_producto: 4,
        id_cliente: 9
      },
      {
        id_producto: 4,
        id_cliente: 1
      },
      {
        id_producto: 4,
        id_cliente: 4
      },
      {
        id_producto: 4,
        id_cliente: 20
      },
      {
        id_producto: 4,
        id_cliente: 21
      }
    ],

    Clientes: [{
        id: 1,
        nombre: "Desechables Nuñez",
        imagen: require("@/assets/images/clientes/desechablesnunez.png"),
        telefono: 8095707025,
        direccion: "Santiago De Los Caballeros 51000",
        id_sector: 0
      },
      {
        id: 2,
        nombre: "DEsteban",
        imagen: require("@/assets/images/clientes/desteban.png"),
        telefono: 8095830000,
        direccion: "Calle Del Sol 70, Santiago De Los Caballeros 51000",
        id_sector: 0
      },
      {
        id: 3,
        nombre: "El Tesoro",
        imagen: require("@/assets/images/clientes/eltesoro.png"),
        telefono: 8095828200,
        direccion: "Av Juan Pablo Duarte, Santiago De Los Caballeros 51000",
        id_sector: 1
      },
      {
        id: 4,
        nombre: "Genere Import",
        imagen: require("@/assets/images/clientes/genere.png"),
        telefono: 8095754142,
        direccion: "Carretera Santiago Navarrete, Santiago De Los Caballeros 51000",
        id_sector: 0
      },
      {
        id: 5,
        nombre: "Janet's Super Market",
        imagen: require("@/assets/images/clientes/janet.png"),
        telefono: 8095719770,
        direccion: " 5, Cabarete 57000",
        id_sector: 1
      },
      {
        id: 6,
        nombre: "Supermercado Lilo S.R.L.",
        imagen: require("@/assets/images/clientes/lilo.png"),
        telefono: 8095793333,
        direccion: "J De La Cruz Alvarez 27, Montecristi.",
        id_sector: 1
      },
      {

        id: 7,
        nombre: "Lucho",
        imagen: require("@/assets/images/clientes/lucho.png"),
        telefono: 8095758888,
        direccion: "Av. 27 de Febrero # 69, Santiago De Los Caballeros 51000",
        id_sector: 0
      },
      {
        id: 8,
        nombre: "Ferretería Hnos Pappaterra",
        imagen: require("@/assets/images/clientes/papaterra.png"),
        telefono: 8095616161,
        direccion: "Antigua Autopista Duarte No.100, Santo Domingo.",
        id_sector: 6
      },
      {
        id: 9,
        nombre: "Pedro Racing",
        imagen: require("@/assets/images/clientes/pedro_racing.png"),
        telefono: 8094890909,
        direccion: "Av. Hatuey, Santiago De Los Caballeros 51000",
        id_sector: 0
      },
      {

        id: 10,
        nombre: "Quirofanos LQ",
        imagen: require("@/assets/images/clientes/quirofanosql.png"),
        telefono: 8096202250,
        direccion: "Calle Abreu No. 68, Santo Domingo 10216",
        id_sector: 5
      },
      {

        id: 11,
        nombre: "Xtra Supermercado",
        imagen: require("@/assets/images/clientes/super_xtra.png"),
        telefono: 8092766000,
        direccion: "Av. 27 de febrero #20, El Dorado 1, Santiago, Av 27 de Febrero, Santiago De Los Caballeros 51000",
        id_sector: 1
      },
      {
        id: 12,
        nombre: "Supermercado Olímpico",
        imagen: require("@/assets/images/clientes/super_olimpico.png"),
        telefono: 8092268908,
        direccion: "Edificio 1, Av. Merelio Almonte 1, Santiago De Los Caballeros",
        id_sector: 1
      },
      {
        id: 13,
        nombre: "Supermercado Trebol",
        imagen: require("@/assets/images/clientes/supertrebol.png"),
        telefono: 8095810595,
        direccion: "Autopista Duarte El embrujo, Santiago, Rep. Dom.",
        id_sector: 1
      },
      {
        id: 14,
        nombre: "Centro Diagnóstico Familiar Dr. Terrero",
        imagen: require("@/assets/images/clientes/terrero.png"),
        telefono: 8095810595,
        direccion: "Calle Restauracion, Santiago De Los Caballeros 51000",
        id_sector: 5
      },
      {
        id: 15,
        nombre: "Tio Pan Panaderia",
        imagen: require("@/assets/images/clientes/tiopan.png"),
        telefono: 8092610787,
        direccion: "Calle J.A. Puig, Puerto Plata 57000",
        id_sector: 0
      },
      {
        id: 16,
        nombre: "AGROVETERINARIA DEL NOROESTE, S.R.L.",
        imagen: require("@/assets/images/clientes/agronor.png"),
        telefono: 8097555066,
        direccion: "Carretera Esperanza-Amina #10, Esperanza, Valverde, República Dominicana",
        id_sector: 0
      },
      {
        id: 17,
        nombre: "Centro de Servicios Moreno",
        imagen: require("@/assets/images/clientes/moreno.png"),
        telefono: 8095254845,
        direccion: "Jose Marti 6, Bonao 42000, República Dominicana",
        id_sector: 0
      },
      {
        id: 18,
        nombre: "Centro Medico Cabarete",
        imagen: require("@/assets/images/clientes/medicocabarete.png"),
        telefono: 8095714696,
        direccion: "CARRETERRA SOSUA CABARETE, SOSUA",
        id_sector: 5
      },
      {
        id: 19,
        nombre: "CIMEN",
        imagen: require("@/assets/images/clientes/cimen.png"),
        telefono: 8097246869,
        direccion: "AV. BARTOLOME COLON. EDIF. COMERCIAL JORGE II, MOD. A-1-125, SANTIAGO",
        id_sector: 5
      },
      {
        id: 20,
        nombre: "Carlos L León",
        imagen: require("@/assets/images/clientes/carloslleon.png"),
        telefono: 8095707501,
        direccion: "km 6, 1 Km 5 1/2, Santiago De Los Caballeros 51000",
        id_sector: 0
      }, {
        id: 21,
        nombre: "Supermercado El Reguero SRL",
        imagen: require("@/assets/images/clientes/reguero.png"),
        telefono: 8095747549,
        direccion: "Calle Independencia #44, centro de la ciudad, Jarabacoa.",
        id_sector: 0
      },
    ],

    SectoresComerciales: [{
        id: 1,
        nombre: "Supermercados",
        imagen: require("@/assets/images/iconos_sectores/supermercados.png"),
        color: "#262626",
        path: "/sectores/retail"
      },
      {
        id: 2,
        nombre: "Distribuidoras",
        imagen: require("@/assets/images/iconos_sectores/distribuidoras.png"),
        color: "#009cff",
        path: "/sectores/industrias"

      },
      {
        id: 3,
        nombre: "Importadoras",
        imagen: require("@/assets/images/iconos_sectores/importadoras.png"),
        color: "#262626",
        path: "/sectores/industrias"
      },
      {
        id: 4,
        nombre: "Mayoristas",
        imagen: require("@/assets/images/iconos_sectores/mayoristas.png"),
        color: "#009cff",
        path: "/sectores/industrias"
      },
      {
        id: 5,
        nombre: "Centros de Salud",
        imagen: require("@/assets/images/iconos_sectores/centrosdesalud.png"),
        color: "#262626",
        path: "/sectores/salud"
      },
      {
        id: 6,
        nombre: "Ferreterías",
        imagen: require("@/assets/images/iconos_sectores/ferreterias.png"),
        color: "#009cff",
        path: "/sectores/industrias"
      },
      {
        id: 7,
        nombre: "Aparta Hoteles",
        imagen: require("@/assets/images/iconos_sectores/apartahoteles.png"),
        color: "#262626",
        path: "/sectores/hoteles"
      },
      {
        id: 8,
        nombre: "Restaurantes",
        imagen: require("@/assets/images/iconos_sectores/restaurantes.png"),
        color: "#009cff",
        path: "/sectores/hosteleria"
      }

    ],

    Noticias: [{
        id: 1,
        imagen: require("@/assets/images/noticias/localadgsystems.jpeg"),
        titulo: "ADGSystems cambia de local",
        subtitulo: "ADGSystems mueve sus instalaciones a un nuevo local",
        fecha: "1 de enero, 2019",
        descripcion: "ADGSystems ha inaugurado un nuevo edificio el cual está ubicado en la calle Rafael Vidal," +
          "esquina tal y tal.",
        descripcionLateral: "Texto Lateral",
        autor: "Ricardo Ventura"
      },
      {
        id: 2,
        imagen: require("@/assets/images/noticias/bi.jpeg"),
        titulo: "Nuevo sistema de Inteligencia Empresarial",
        subtitulo: "Bi, el nuevo sistema de inteligencia empresarial",
        fecha: "2 de enero, 2019",
        descripcion: "El nuevo sistema de inteligencia empresarial (BI) revolucionara el mercado laboral con sus" +
          " increíbles nuevas funciones para mejorar tu negocio",
        descripcionLateral: "Texto Lateral",
        autor: "Ricardo Maldonado"
      },
    ],

    /* Layouts de la página */
    layoutHeader: 'header-cliente',
    layoutFooter: 'footer-cliente',
    /* --- */

    /* --- Sector --- */
    sector: [],
    sectorClientes: [],
    sectorProductos: [],
    modalProducto: [],
    /* --- */
    /* ------------- */
    colorHeader: false
    /* ------------- */

  },
  mutations: {
    setIndexProducto: (state, newValue) => {
      var indexProducto = newValue
      state.modalProducto = [];
      state.Productos.forEach(item => {
        if (item.id == indexProducto) {
          state.modalProducto.push(item);
        }
      })
    },
    setTransparencia: (state, HeaderTransparencia) => {
      state.HeaderTransparencia = HeaderTransparencia;
    }
  }
})